import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        this.arrowNext = this.$('next')[0]
        this.arrowPrev = this.$('prev')[0]
    }

    init() {
        this.length = this.$('item').length

        this.swiper = new Swiper(this.$('slider')[0], {
            speed: 600,
            direction: 'horizontal',
            slidesPerView: 1.1,
            loop: true,
            loopedSlides: 3,
            preloadImages: false,
            navigation: {
                nextEl: this.arrowNext,
                prevEl: this.arrowPrev,
            },
            breakpoints: {
                1200: {
                    slidesPerView: 2.1,
                    direction: 'vertical',
                    loop: false
                },
                1000: {
                    slidesPerView: 2.5,
                    direction: 'vertical',
                    loop: false
                }
            },
            on: {
                slideChange: () => {
                    this.swiper.lazy.load()
                }
            }
        });

        let viewportWidth = window.innerWidth || document.documentElement.clientWidth;
        if (viewportWidth < 700) {
            if(this.length > 0) {
                this.arrowPrev.classList.remove('is-invisible')
                this.arrowNext.classList.remove('is-invisible')
            }
        } else {
            if(this.length > 2) {
                this.arrowPrev.classList.remove('is-invisible')
                this.arrowNext.classList.remove('is-invisible')
            }
        }
    }

    inview(e) {
        this.swiper.lazy.load()
    }

    close() {
        if(this.swiper.params.loop) {
            this.swiper.slideToLoop(0);
        } else {
            this.swiper.slideTo(0);
        }
    }
}
